import { Fade } from "react-awesome-reveal";
import IconLogo from "../assets/img/icon-logo.png";
import CurveArrowTwo from "../assets/img/gcgtc.png";
import Screen1 from "../assets/img/screen1.png";
import Screen2 from "../assets/img/screen2.png";
import Screen3 from "../assets/img/screen3.png";
import Screen4 from "../assets/img/screen4.png";
import Screen5 from "../assets/img/screen5.png";
import Slider from "react-slick";

const CaseItem = ({ screen }) => (
        <img src={screen} alt="my-screen" className="z-10 relative transition duration-500 ease-in-out w-[100%] h-full object-contain hover:scale-[0.85]" />
)

const ShowCase = () => {
    const settings = {
        arrows: false,
        dots: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 50,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                arrows: false,
                centerMode: true,
                slidesToShow: 3
              }
            },
            {
              breakpoint: 640,
              settings: {
                arrows: false,
                centerMode: true,
                slidesToShow: 1
              }
            }
        ]
    };
    const screens = [Screen1, Screen2, Screen3, Screen4, Screen5]

    return (
            <div id="Showcase" className='min-h-full bg-[#FFF] px-[15px] xs:px-[30px] lg:px-[57px] pt-[90px] relative z-10'>
                <Fade direction="up" triggerOnce={true} duration={1500}>
                    <div className="text-[#353736] not-italic font-[700] text-[43px] leading-[36px] sm:leading-[150%] text-center relative">
                        Showcase
                        <img src={IconLogo} alt="icon-logo" className="App-logo absolute top-[-40px] sm:top-[0] left-0 z-10 w-[50px]" />
                    </div>
                </Fade>
                <div className="h-[calc(100%-190px)] w-full absolute left-0 pb-3 mt-3">
                    <div className="h-full z-10 relative before:content-[''] before:bg-gradient-to-r before:from-[#FFF_0%] before:to-[rgba(119,199,224,0)_100%] before:absolute before:h-full before:w-[4rem] md:before:w-[10rem] before:z-10 after:content-[''] after:bg-gradient-to-r after:from-[#FFF_0%] after:to-[rgba(119,199,224,0)_100%] after:absolute after:h-full after:w-[4rem] md:after:w-[10rem] after:top-0 after:right-0 after:rotate-180 after:z-10">
                        <Slider {...settings}>
                            {screens.map((items, index) => (
                                <CaseItem key={`showcase_${index}`} screen={items} />
                            ))}
                        </Slider>
                    </div>
                    <img src={CurveArrowTwo} alt="arrow" className="absolute left-[5rem] z-0 w-[160px] bottom-[20px] rotate-[67deg]" />
                </div>
            </div>
    )
}

export default ShowCase;